export default [
	{
		name: 'root',
		label: 'Wrapper',
		selector: '&'
	},

	{
		name: 'form',
		label: 'Form',
		selector: '& .form'
	},

	{
		name: 'title',
		label: 'Title',
		selector: '& .title'
	},

	{
		name: 'fields',
		label: 'Fields',
		selector: '& .fields'
	},

	{
		name: 'field',
		label: 'Field',
		selector: '& .field'
	},

	{
		name: 'label',
		label: 'Label',
		selector: '& .label'
	},

	{
		name: 'input',
		label: 'Input',
		selector: '& .input'
	},

	{
		name: 'textarea',
		label: 'Textarea',
		selector: '& .textarea'
	},
	{
		name: 'button',
		label: 'Button',
		selector: '& .baseButton'
	},
]